import type { StringRecord } from '@types';

interface RequestConfig {
  formConfig: {
    path: string;
    endPath?: string;
  };
  params?: StringRecord;
  endPath?: boolean;
}

interface RequestUrlResult {
  url: string;
  requestParams?: {
    params: StringRecord;
  };
}

export const getApiRequestUrl = ({ formConfig, params, endPath }: RequestConfig): RequestUrlResult => {
  const { path, endPath: lastPath } = formConfig;
  let url = path;

  if (params?.content_id) {
    url += `/${params.content_id}`;
  }

  if (endPath && lastPath) {
    url += lastPath;
  }

  const requestParams = params
    ? {
        params: Object.fromEntries(Object.entries(params).filter(([key]) => key !== 'content_id')),
      }
    : undefined;

  return { url, requestParams };
};
